import axios from "./axios-handler.service";
const BASE_URL_ENVIOS_AUTOMATICOS_DIARIO = "/api/EnviosAutomaticosExecucoesDiarias";

export interface EnvioAutomaticoExecucaoDiaria {
  idEnvioAutomatico: string;
  dataExecucao: string;
  dataCriacao: string;
  quantidadeEnviada: number;
  quantidadePendente: number;
  quantidadeFalha: number;
  total: number;
}

export interface FiltroEnviosAutomaticosExecucoesDiarias {
  dataInicio: string;
  dataFim: string;
  offset: number;
  limit: number;
  order?: string;
}

export class EnviosAutomaticosExecucoesDiariasService {
  static async listarEnviosAutomaticosExecucoesDiarias(
    filtro: FiltroEnviosAutomaticosExecucoesDiarias
  ): Promise<EnvioAutomaticoExecucaoDiaria[]> {
    const { dataInicio, dataFim, offset, limit, order } = filtro;
    const response = await axios.get<EnvioAutomaticoExecucaoDiaria[]>(
      `${BASE_URL_ENVIOS_AUTOMATICOS_DIARIO}/ListarPaginadoPorData`,
      {
        params: {
          dataInicio, 
          dataFim,
          offset,
          limit,
          order,
        },
      }
    );
    return response.data;
  }
}